// ------------------------------------------------------------------------------
// name: status
// author: mudas
// created: 2025/9/11
// ------------------------------------------------------------------------------

export enum ActivityType {
  // 未开始
  Ready = 'PENDING',
  // 进行中
  Start = 'RUNNING',
  // 已结束
  End = 'ENDED',
  // 已取消（预留，暂未启用）
  Canceled = 'CANCELED',
}

export const ActivityTypeName = {
  [ActivityType.Ready]: '未开始',
  [ActivityType.Start]: '进行中',
  [ActivityType.End]: '已结束',
  [ActivityType.Canceled]: '已取消',
};